module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f4ab.1b3817ca.svg";